import React from "react";
import ReactPaginate from "react-paginate";

interface PaginationProps {
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  currentPage: number; 
}

const PaginationComponent: React.FC<PaginationProps> = ({
  totalItems,
  itemsPerPage,
  onPageChange,
  currentPage,
}) => {
  const pageCount = Math.ceil(totalItems / itemsPerPage);
  const handlePageClick = (selected: { selected: number }) => {
    onPageChange(selected.selected);
  };

  return (
    <ReactPaginate
      forcePage={currentPage} // ensures the active page reflects your state
      previousLabel={"< Previous"}
      nextLabel={"Next >"}
      breakLabel={"..."}
      pageCount={pageCount}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={handlePageClick}
      containerClassName="flex items-center justify-center mt-8 space-x-2"
      pageClassName="hidden sm:block bg-white border border-neutral-300 rounded-md hover:bg-primary-100 dark:bg-gray-800 dark:border-gray-600 dark:hover:bg-primary-200"
      pageLinkClassName="px-4 py-2 text-sm font-medium text-neutral-600 dark:text-neutral-300"
      activeClassName="!bg-primary-6000 !text-white rounded-md"
      activeLinkClassName="text-neutral-10 hover:text-neutral-50"
      previousClassName="bg-white border border-neutral-300 rounded-md hover:bg-primary-100 dark:bg-gray-800 dark:border-gray-600 dark:hover:bg-primary-200"
      previousLinkClassName="px-4 py-2 text-sm font-medium text-neutral-600 dark:text-neutral-300"
      nextClassName="bg-white border border-neutral-300 rounded-md hover:bg-primary-100 dark:bg-gray-800 dark:border-gray-600 dark:hover:bg-primary-200"
      nextLinkClassName="px-4 py-2 text-sm font-medium text-neutral-600 dark:text-neutral-300"
      breakClassName="bg-white border border-neutral-300 rounded-md dark:bg-gray-800 dark:border-gray-600"
      breakLinkClassName="px-4 py-2 text-sm font-medium text-neutral-600 dark:text-neutral-300"
      disabledClassName="opacity-50 cursor-not-allowed"
    />
  );
};

export default PaginationComponent;